<template>
  <div class="pay">
    <div class="vip">
      <div class="vip-top">
        <img src="../../assets/images/1-1.png" alt="Alternate Text" />
      </div>
      <div class="vip-txt">
        <span></span>
        开通V卡会员 享专属特权
        <span></span>
      </div>
    </div>
    <div class="payment">
      <div class="pay-leb mode">
        购买权益
        <span>V卡会员</span>
      </div>
      <div class="pay-leb buyAge">
        使用年限
        <span class="recid" v-if="limitDateYear > 0">{{limitDateYear}}</span>
        <span v-if="limitDateYear > 0">年</span>
        <span class="recid" v-if="limitDateMonth > 0">{{limitDateMonth}}</span>
        <span v-if="limitDateMonth > 0">月</span>
      </div>
      <div class="pay-leb money">
        应付金额
        <span class="sheep">￥</span>
        <span :class="{'firstPrice':isDel}">{{isDelNum}}</span>
        <span class="discountPrice" v-if="isDel">{{salePrice}}</span>
        <span v-else>{{salePrice}}</span>
      </div>
      <div class="pay-but" @click='checkMemberInfo'>

        <a class="payBtn" href="javascript:;">立即支付</a>
      </div>
      <div class="clause">
        <span></span>
        <a href="https://m.gdtvdv.com/Wap/Shop/docview.aspx?uid=308">开通则同意《V卡会员正式用户协议》</a>
      </div>
    </div>
    <div class="privilege">
      <img class="big-img" src="@/assets/newmember/topImg.jpg" alt="">
    </div>
    <!-- 确认信息 -->
    <div class="info_map" v-if="is_info_show">
      <div class="mask"></div>
      <div class="info_box">
        <div class="title">信息确认</div>
        <div class="info_detail">
          <div class="info_con">
            <div class="left">姓名：</div>
            <div class="right">{{name}}</div>
          </div>
          <div class="info_con">
            <div class="left">地址：</div>
            <div class="right">{{Address}}</div>
          </div>
          <div class="info_con">
            <div class="left">手机：</div>
            <div class="right">{{Phone}}</div>
          </div>
        </div>
        <div class="info_bottom">
          <div class="info_yes" @click="CloseInfoMap">确认</div>
          <div class="info_eit" @click="editinfo">修改</div>
        </div>
      </div>
    </div>
    <div class="foot">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>

</template>

<script>
import MbrService from "../../services/mbrservice.js";
import cardService from "../../services/card-service.js";
import jssdkService from "../../services/jssdk-service.js";
export default {
  data() {
    return {
      limitDateYear: 0, //年限
      limitDateMonth: 0, //年限
      salePrice: "", //会员价格
      payId: "", //支付方式
      ProductNo: "", //产品编码
      MemberAccount: "", //会员账号
      orderdisable: true,
      PayUrl: "",
      is_info_show: false,
      Address: "",
      Phone: "",
      name: "",
      isDel: false,
      isDelNum: '', //原先价格
      isDiscountRecid: null,
      payKind: '' // 支付方式（判断是公众号还是APP）
    };
  },
  methods: {
    // 获取会员卡信息
    getCart() {
      new cardService().getCardInfo({"ProductNo":this.$route.query.proNo}).then(res => {
        if (res.ErrorCode == -2) {
          //未登陆
        } else if (res.ErrorCode == 0) {
          // MemberAccount:"dvshoptest" 测试接口信息
          new cardService().getCardDiscount().then(data => {
            if(data.Data){
              // 存在即有优惠
              if(data.Data.DiscountRate){
                this.isDel = true
                this.isDelNum = res.Data.SalePrice
                this.isDiscountRecid = data.Data.DiscountRecid
                this.salePrice = res.Data.SalePrice*data.Data.DiscountRate
              } else {
                this.isDel = false
                this.salePrice = res.Data.SalePrice
              }
            } else {
              // 不存在即没有优惠
              
              if(res.Data.DiscountFee && res.Data.DiscountFee > 0) {
                this.isDel = true
                this.isDelNum = res.Data.SalePrice
                this.salePrice = res.Data.SalePrice - res.Data.DiscountFee
              } else {
                this.isDel = false
                this.salePrice = res.Data.SalePrice - res.Data.DiscountFee
              }
            }
            
          })
          // this.isDelNum = res.Data.SalePrice;
          let time = JSON.parse(res.Data.DateConfig)
          this.limitDateYear = time.Year;
          this.limitDateMonth = time.Month
          // this.limitDate = res.Data.LimitDate;
          // this.ProductNo = res.Data.CartNo;
          this.ProductNo = this.$route.query.proNo;
          this.orderdisable = false;
        }
      });
    },
    //判断是否且在有效期
    IsBuy() {
      new MbrService().isBind({}).then(res => {
        if (res.Data.IsBuy == 1) {
          //购买过了
          //判断是否过期
          // var timeSrc = res.Data.EndTime.replace(" ", "T");
          // var Year = new Date().getFullYear() + 1;
          // var Month = (new Date().getMonth()+1)<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1);
          // var Day = new Date().getDate()<10?'0'+new Date().getDate():new Date().getDate();
          // var Hours = new Date().getHours()<10?'0'+new Date().getHours():new Date().getHours();
          // var Seconds = new Date().getSeconds()<10?'0'+new Date().getSeconds():new Date().getSeconds();
          // var Minutes = new Date().getMinutes()<10?'0'+new Date().getMinutes():new Date().getMinutes();
          // var nowtime =Year +"-" +Month +"-" +Day +"T" +Hours +":" +Minutes +":" +Seconds;
          // if (new Date(timeSrc).getTime() > new Date(nowtime).getTime()) {
          //   this.$router.push({ path: "/home" });
          // }
        }
      });
    },
    CloseInfoMap() {
      this.is_info_show = false;
      new MbrService().isBind({}).then(res => {
        if (res.Data.IsBind == 0) {
          //未绑定
          this.$router.push({ path: "/info" });
        } else if (res.Data.IsBind == 1) {
          //绑定了
          this.summitOrder();
        } else {
          alert("支付异常，请联系客服");
        }
      });
    },
    editinfo() {
      this.$router.push({ path: "/editinfo" });
    },
    // 判断是否有绑定信息
    checkMemberInfo() {
      new MbrService().LaodMemberInfo().then(res => {
        var obj = res.Data;
        var Province = obj.Province ? obj.Province : "";
        var City = obj.City ? obj.City : "";
        var Area = obj.Area ? obj.Area : "";
        var Address = obj.Address ? obj.Address : "";
        this.Address = Province + City + Area + Address;
        this.Phone = obj.Phone;
        this.name = obj.Name;
      });
      this.is_info_show = true;
    },
    //支付方式
    GetPaymentList() {
      // debugger;
      console.log(this.payKind)
      new cardService().GetPaymentList({'kind': this.payKind}).then(res => {
        if (res.ErrorCode == 0) {
          this.payId = res.Data.PaymentInfo.Id;
          this.PayUrl = res.Data.PaymentInfo.PayUrl;
          this.orderdisable = false;
        }
      });
    },
    //支付
    summitOrder() {
      // c创建订单
      new MbrService()
        .CreateOrder({
          ProductNo: this.ProductNo,
          PayId: this.payId,
          DiscountRecid: this.isDiscountRecid 
        })
        .then(res => {
          var order = res.Data;
          // 支付
          new cardService()
            .GetPaymentInfoCommand({ PayId: res.Data.PayId })
            .then(res => {
              if (res.ErrorCode == 0) {
                if(navigator.userAgent.indexOf('gdtv-shop') > -1){
                  location.href = "/index.html#/AppPay?payno=" + order.PayNo;
                } else {
                  // location.href = res.Data.PayUrl + "?payno=" + order.PayNo;
                  location.href = "/index.html#/weiXinpay?payno=" + order.PayNo;
                }
              }
              if (res.ErrorCode == -1) {
                alert("支付方式不正确");
              }
            });
        });
    }
  },
  created() {
    // app内： "Kind": "APPWXPAY"
      // 其他："Kind": "WXPAY"
      // 判断是否在app内 
    this.payKind = ''
    var ua = navigator.userAgent.toLowerCase();
    if(ua.indexOf('gdtv-shop') > -1){
      this.payKind  = "APPWXPAY"
    } else if(ua.match(/MicroMessenger/i)=="micromessenger") { // 判断是否在微信浏览器中
      wx.miniProgram.getEnv((res)=>{
          if (res.miniprogram) {
            //  alert("在小程序里");
            this.payKind = "XCXPAY"
          } else {
            //  alert("不在小程序里");
            this.payKind = "WXPAY"
          }
      })
    } else {
      this.payKind = "WXPAY"
    }
    this.getCart();
    // this.IsBuy();
    new jssdkService().IntData()
  },
  mounted() {
    this.GetPaymentList();

  }
};
</script>

<style scoped>
.pay {
  background: url("../../assets/images/1-2.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 100%;
  margin: 0 auto;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
}

::-webkit-scrollbar-thumb {
  width: 0;
  height: 0;
}

* {
  margin: 0;
  padding: 0;
}

.clearfix::after {
  content: "";
  display: block;
  height: 0;
  line-height: 0;
  clear: both;
  font-size: 0;
}

/* vip */

.vip {
  padding: 0.2rem 0;
}

.vip-top {
  width: 0.59rem;
  height: 0.46rem;
  margin: 0 auto;
  position: relative;
}

.vip-top img {
  width: 0.59rem;
  height: 0.46rem;
  position: absolute;
  top: 0;
}

.vip .vip-txt {
  margin-top: 0.2rem;
  font-size: 0.28rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0px;
  letter-spacing: 0px;
  color: #ffd957;
  line-height: 0.2rem;
  height: 0.2rem;
  text-align: center;
}

.vip .vip-txt span {
  display: inline-block;
  height: 1px;
  width: 0.8rem;
  background-color: rgba(247, 219, 115, 0.8);
  opacity: 0.8;
  margin: 0.1rem;
}

/* 立即支付 */

.payment {
  margin: 0.16rem;
  background: #fff url("../../assets/images/1-8.png") no-repeat;
  background-size: 3rem 1.9rem;
  background-position: 3.1rem 1.28rem;
  border-radius: 0.1rem;
  height: 4rem;
  box-shadow: -0.02rem 0.05rem 18px 0 #1a2a292b;
  margin-bottom: 0.33rem;
}

.payment .pay-leb {
  height: 0.8rem;
  border-bottom: 1px solid #eee;
  font-size: 0.26rem;
  line-height: 0.8rem;
  padding-left: 0.1rem;
  color: #3b3b3b;
}
.payment .pay-leb .firstPrice{
  text-decoration:line-through;
  font-size: 0.2rem; 
}
.payment .pay-leb .discountPrice{
  color: red;
}
.payment .pay-leb span {
  color: #bfa33d;
}

/* .payment .pay-leb .sheep {
  font-size: 0.16rem;
} */

.payment .pay-leb .hint {
  color: #7b7777;
  font-size: 0.2rem;
}

.pay-but {
  padding: 0 0.74rem;
  padding-top: 0.2rem;
}

.pay-but a {
  display: block;
  text-align: center;
  text-decoration: none;
  line-height: 0.68rem;
  width: 100%;
  height: 0.68rem;
  border: none;
  background: #e5ce78;
  font-size: 0.36rem;
  color: rgba(59, 59, 59, 0.9);
  border-radius: 0.34rem;
  box-shadow: -0.02rem 0.05rem 13px 0px #212a292b;
}

.payment .clause {
  text-align: center;
  position: relative;
}

.payment .clause a {
  display: block;
  text-align: center;
  width: 100%;
  text-decoration: none;
  color: rgba(59, 59, 59, 0.5);
  font-size: 0.18rem;
  position: absolute;
  top: 0.2rem;
}

.payment .pay-but .cue {
  font-size: 0.26rem;
  color: #7b7777;
  padding-bottom: 0.2rem;
  padding-left: 0.5rem;
}

.pay-but .cue span {
  display: inline-block;
  background-color: #e8c580;
  padding: 0.1rem;
  border-radius: 50%;
  margin-right: 0.1rem;
}

/* 特权 */

.privilege {
  width: 100%;
  background: #fff;
}

.privilege .big-img {
  width: 100%;
}

.privilege .privilege-title {
  text-align: center;
  font-size: 0.34rem;
  color: #2a2a2a;
  padding: 0.3rem 0;
  position: relative;
}

.privilege .privilege-title img {
  width: 0.3rem;
  position: absolute;
  right: 0.24rem;
  top: 0.3rem;
  display: none;
}

.privilege .privilege-title span {
  display: inline-block;
  height: 1px;
  width: 1rem;
  background-color: rgba(0, 0, 0, 0.4);
  margin: 0.1rem;
}

.privilege .ser {
  height: 1.5rem;
  border-bottom: 1px solid #eee;
  padding-left: 0.65rem;
}

.ser-img {
  width: 0.52rem;
}

.pre-img {
  width: 0.57rem;
}

.privilege-imgBox {
  float: left;
}

.pri-txt {
  float: left;
  padding-left: 0.3rem;
  padding-top: 0.3rem;
}

.privilege .pri-txt .pri-txt-top {
  font-size: 0.36rem;
  color: #2a2a2a;
}

.privilege .pri-txt .pri-txt-bottom {
  font-size: 0.24rem;
  color: rgba(42, 42, 42, 0.6);
}

.foot {
  margin-top: 0.5rem;
}

.foot div:nth-child(1) {
  height: 0.27rem;
  border-top: 1px solid #e5ce78;
}

.foot div:nth-child(2) {
  height: 0.44rem;
  background: #aeaeae;
}

.foot div:nth-child(3) {
  height: 0.62rem;
  background: #505050;
}

/* 信息 */
.info_map {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.info_map .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
  top: 0;
  left: 0;
}
.info_map .info_box {
  position: absolute;
  width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 0.1rem;
  /* padding: .2rem; */
}
.info_map .info_box .title {
  font-size: 0.3rem;
  text-align: center;
  padding: 0.3rem 0;
  font-weight: bold;
}
.info_map .info_box .info_con {
  padding: 0 0.2rem;
  word-wrap: break-word;
  font-size: 0.28rem;
  color: #474747;
  margin-bottom: 0.1rem;
}
.info_map .info_con .left {
  width: 20%;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}
.info_map .info_con .right {
  width: 78%;
  display: inline-block;
}
.info_map .info_bottom {
  border-top: 1px solid #ccc;
  height: 0.7rem;
  position: relative;
  margin-top: 0.3rem;
}
.info_map .info_bottom > div {
  display: inline-block;
  width: 48%;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  color: #bfa33d;
  font-size: 0.36rem;
  position: absolute;
  top: 0;
}
.info_map .info_bottom .info_yes {
  left: 0;
  border-right: 1px solid #ccc;
}
.info_map .info_bottom .info_eit {
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/component/pay/Pay.vue